import bee from "./Bee";
export default {
    name: "Shared",
    /*
        var query = {
            seed: {
                category: [45]
            }
        }
    */
    /* eslint-disable no-unused-vars */
    get_dependence(query, success, fail) {
        var query_struct = {
            _box: {
                scan_limit: 11,
                seeds: {
                    ... query.seed
                }
            },
            _f_br: "dependence_report"
        }
        bee.get(query_struct).then(res => {
            success(res);
        }).catch(errors => {
            fail(errors);
        });
    },
    /*
        var query = {
            seed: {
                category: [45]
            }
        }
    */
    /* eslint-disable no-unused-vars */
    delete_items(query, success, fail) {
        var query_struct = {
            _box: {
                seeds: {
                    ... query.seed
                }
            },
            _f_br: "delete_items"
        }
        bee.get(query_struct).then(res => {
            success(res);
        }).catch(errors => {
            fail(errors);
        });
    },
}